const CHARACTERS = {
    0: 'magic',
    1: 'waffles',
    2: 'costume_and_gemini',
    3: 'pallas',
    4: 'bit_mac',
    5: 'set',
    6: 'luminous_gemini',
    7: 'gemini',
    8: 'pepper',
    9: 'gemini',
    10: 'hiro',
    11: 'good_aero',
    12: 'lead',
    13: 'costume_and_gemini',
    14: 'bit_mac',
    15: 'regalia',
    16: 'juno',
    17: 'ender',
    18: 'good_aero',
    19: 'gemini_ball',
    20: 'pallas',
    21: 'gemini_ball',
    22: 'waffles',
    23: 'lead',
    24: 'tofu',
    25: 'regalia',
    26: 'pepper',
    27: 'luminous_gemini',
    28: 'gemini_ball',
    29: 'kimchi',
    30: 'reaktor',
    31: 'magic',
    32: 'good_aero',
    33: 'juno',
    34: 'pepper',
    35: 'bit_mac',
    36: 'costume_and_gemini',
    37: 'pallas',
    38: 'luminous_aero',
    39: 'pallas',
    40: 'reaktor',
    41: 'kimchi',
    42: 'costume_and_gemini',
    43: 'ender',
    44: 'juno',
    45: 'regalia',
    46: 'gemini_ball',
    47: 'icy_hot',
    48: 'luminous_gemini',
    49: 'limited_ender',
    50: 'limited_ender',
    51: 'reaktor',
    52: 'magic',
    53: 'waffles',
    54: 'lead',
    55: 'juno',
    56: 'regalia',
    57: 'pallas',
    58: 'luminous_gemini',
    59: 'pepper',
    60: 'hiro',
    61: 'gemini',
    62: 'ender',
    63: 'magic',
    64: 'nord',
    65: 'hiro',
    66: 'costume_and_gemini',
    67: 'bit_mac',
    68: 'regalia',
    69: 'luminous_gemini',
    70: 'rhombus',
    71: 'kimchi',
    72: 'luminous_aero',
    73: 'pallas',
    74: 'limited_costume',
    75: 'lead',
    76: 'tofu',
    77: 'waffles',
    78: 'waffles',
    79: 'luminous_gemini',
    80: 'rhombus',
    81: 'hiro',
    82: 'reaktor',
    83: 'pepper',
    84: 'good_aero',
    85: 'costume_and_gemini',
    86: 'pepper',
    87: 'regalia',
    88: 'bit_mac',
    89: 'ender',
    90: 'luminous_gemini',
    91: 'pepper',
    92: 'limited_ender',
    93: 'gemini',
    94: 'magic',
    95: 'gemini',
    96: 'luminous_aero',
    97: 'tofu',
    98: 'regalia',
    99: 'waffles'
};

const ELEMENTS = {
    0: 'healer',
    1: 'mystic',
    2: 'luminous',
    3: 'warrior',
    4: 'elemental',
    5: 'magician',
    6: 'healer',
    7: 'warrior',
    8: 'elemental',
    9: 'magician'
};

const ATTRIBUTES = {
    0: [ 'maxDF', 'maxSA', 'winFire' ],
    1: [ 'maxDF', 'maxSA', 'winFire' ],
    2: [ 'maxDF', 'maxSA', 'winFire' ],
    3: [ 'maxDF', 'maxSA', 'winFire' ],
    4: [ 'maxDF', 'maxSA', 'winFire' ],
    5: [ 'maxDF', 'maxSA', 'winFire' ],
    6: [ 'maxDF', 'maxSA', 'winFire' ],
    7: [ 'maxDF', 'maxSA', 'winFire' ],
    8: [ 'maxDF', 'maxSA', 'winFire' ],
    9: [ 'maxDF', 'maxSA', 'winFire' ]
};

const GEN_0_CARDS = {
    0: 'regalia',
    1: 'bit_mac',
    2: 'tofu',
    3: 'magic',
    4: 'gemini',
    5: 'gemini_ball',
    6: 'luminous_aero',
    7: 'ender',
    8: 'luminous_gemini',
    9: 'pepper',
    10: 'pallas',
    11: 'waffles',
    12: 'rhombus',
    13: 'nord',
    14: 'lead',
    15: 'kimchi',
    16: 'hiro',
    17: 'good_aero',
    18: 'set',
    19: 'costume_and_gemini',
    20: 'reaktor',
    21: 'juno',
    22: 'limited_ender',
    23: 'limited_costume'
}

const GEN_X_CARDS = {
    0: 'costume_flame',
    1: 'aero_sweep',
    2: 'crypto_fusion',
    3: 'set_attack'
}

export { CHARACTERS, ELEMENTS, ATTRIBUTES, GEN_0_CARDS, GEN_X_CARDS };


// WEBPACK FOOTER //
// ./src/util/constants/cards.js